<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <div class="response-container">
      <h1>PCS 04 API Response</h1>
      <b-row>
        <b-col md="3">
          <label>Interface Name</label>
          <b-form-input
            :formatter="capitalizeAll"
            disabled
            id="interfaceName"
            name="interfaceName"
            v-model="interfaceName"
          ></b-form-input
        ></b-col>
        <b-col md="3">
          <label>BOE Number (2159404)</label>
          <b-form-input
            :formatter="capitalizeAll"
            id="boeNumber"
            name="boeNumber"
            v-model="boeNumber"
          ></b-form-input
        ></b-col>
        <b-col md="3">
          <b-button
            v-if="interfaceName && boeNumber"
            @click="getAllPCS04Func()"
            size="sm"
            variant="info"
            style="font-size: 0.675rem; margin-left: 5px; margin-bottom: 4px"
            >Fetch</b-button
          >
        </b-col>
      </b-row>
      <hr />
      <div
        v-if="
          !getAllPcs04 ||
          !getAllPcs04[0] ||
          getAllPcs04[0].response[0].responseMsg === 'not found'
        "
      >
        <b class="text-danger">No data found.</b>
      </div>
      <div v-else>
        <b-row v-if="getAllPcs04.length > 0">
          <b-col md="3" class="mt-1 mb-1">
            <strong>Items Igm No:</strong>
            {{ getAllPcs04[0].response[0].items_IgmNo || "N/A" }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Items Bill Of Entry Date:</strong>
            {{ getAllPcs04[0].response[0].items_BillOfEntryDate || "N/A" }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Subline No:</strong>
            {{ getAllPcs04[0].response[0].sublineNo || "N/A" }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Nature of Cargo:</strong>
            {{ getAllPcs04[0].response[0].natureOfCargo || "N/A" }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Items Igm Date:</strong>
            {{ getAllPcs04[0].response[0].items_IgmDate || "N/A" }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Items Sub Line Number:</strong>
            {{ getAllPcs04[0].response[0].items_sub_line_number || "N/A" }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Igm Date:</strong>
            {{ getAllPcs04[0].response[0].igmDate || "N/A" }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Number of Packages:</strong>
            {{ getAllPcs04[0].response[0].numberOfPackages || "N/A" }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Sub Line Number:</strong>
            {{ getAllPcs04[0].response[0].sub_line_number || "N/A" }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Gross Weight:</strong>
            {{ getAllPcs04[0].response[0].grossWeight || "N/A" }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Line No:</strong>
            {{ getAllPcs04[0].response[0].lineNo || "N/A" }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Custom House Code:</strong>
            {{ getAllPcs04[0].response[0].customHouseCode || "N/A" }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Line Number:</strong>
            {{ getAllPcs04[0].response[0].line_number || "N/A" }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Bill Of Entry No:</strong>
            {{ getAllPcs04[0].response[0].billOfEntryNo || "N/A" }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Container No:</strong>
            {{ getAllPcs04[0].response[0].container_no || "N/A" }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Country Of Origin:</strong>
            {{ getAllPcs04[0].response[0].countryOfOrigin || "N/A" }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Items Line Number:</strong>
            {{ getAllPcs04[0].response[0].items_line_number || "N/A" }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>CHA Code:</strong>
            {{ getAllPcs04[0].response[0].chaCode || "N/A" }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Unit Of Quantity:</strong>
            {{ getAllPcs04[0].response[0].unitOfQuantity || "N/A" }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Items Bill Of Entry No:</strong>
            {{ getAllPcs04[0].response[0].items_BillOfEntryNo || "N/A" }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Bill Of Entry Date:</strong>
            {{ getAllPcs04[0].response[0].billOfEntryDate || "N/A" }}
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import UlipService from "../../services/UlipService.js";
import CustomLoader from "../common/customLoader.vue";
import { globalPermissionStatus } from "../../helper/collection.js";
export default {
  beforeMount() {
    this.$store.dispatch("setCurrentRoute", this.$route.path);
    if (globalPermissionStatus("Dashboard_Access") || globalPermissionStatus("ULIP")) {
      // this.getAllPCS04Func();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      interfaceName: "CHPOI09",
      boeNumber: "",
      getAllPcs04: null,
      isLoading: false,
      error: false,
      code: 200,
      message: "Success",
    };
  },

  filters: {},

  mounted() {},

  beforeDestroy() {},

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    CustomLoader,
  },

  methods: {
    async getAllPCS04Func() {
      let payload = {};
      this.isLoading = true;
      this.getAllPcs04 = null;

      if (this.interfaceName && this.boeNumber) {
        payload = {
          itemCode: "PCS04",
          funcUrl: "PCS/04",
          interfaceName: this.interfaceName,
          boeNumber: this.boeNumber,
        };

        payload = JSON.stringify(payload);
        UlipService.getAllUlipList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              console.log("getAllPcs04 PS =>", data.getAllPcs04.response.response);
              if (
                data.getAllPcs04.response.response &&
                data.getAllPcs04.response.response.length > 0
              ) {
                this.getAllPcs04 = data.getAllPcs04.response.response;
              }
              this.isLoading = false;
            }
          })
          .catch((error) => {
            console.log("Catch on getAllPcs04 Error: ", error);
          });
      }
    },
  },
};
</script>

<style scoped>
.response-container {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

h1 {
  font-size: 24px;
  margin-bottom: 20px;
}

ul {
  list-style: none;
  padding: 0;
}

li {
  margin-bottom: 10px;
  font-size: 18px;
}

strong {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// PCS04_ResponseDisplay.vue?b7d678a6